

































import { defineComponent, ref, watch } from '@vue/composition-api';

import ConnectItems from '@/components/ConnectItems.vue';
import { Exercise } from '@/helpers/types';

export default defineComponent({
  name: 'ExerciseForm',

  components: {
    ConnectItems,
  },

  props: {
    mode: {
      type: String,
      default: () => 'create',
    },
    categories: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    exercise: {
      type: Object,
      default: () => {},
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    }
  },

  setup(props, { emit }) {
    const selected = ref([]);

    /**
     * Handler fro submit event
     * */
    function submitEventHandler() {
      if (selected.value.length) {
        const payload = {
          exercise: selected.value.map((exercise: Exercise) => exercise.id),
        };
        emit(`${props.mode}-exercise`, payload);
      } else {
        throw new Error('You didn`t select questions!');
      }
    }

    /**
     * Handler for connect items change event
     * @param {any} items
     * */
    function connectItemsChangeEventHandler (items: any) {
      selected.value = items;
    }

    /**
     * Handler for close event
     * */
    function closeEventHandler() {
      emit('close');
    }

    watch(() => props.exercise, (value, prevValue) => {
      console.debug(value, prevValue);
    });

    return {
      submitEventHandler,
      connectItemsChangeEventHandler,
      closeEventHandler,
    };
  },
});
